export default "__VITE_ASSET__DftiiD4x__"